import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { CarrierFavoriteFilterModel, FilterDeleteModel, FilterObligationByUserModel, FilterObligationUpdateModel } from 'src/Models/ObligationUpdatesModel';

@Injectable({
  providedIn: 'root'
})
export class View47DeleteService {

  AppUrl = '';
  filterObligationUpdateModel = new FilterObligationUpdateModel;
  CarrierFavoriteFilterModel = new CarrierFavoriteFilterModel;
  FilterObligationByUserModel = new FilterObligationByUserModel;
  FilterDeleteModel = new FilterDeleteModel;

  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  View47DeleteAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/View47DeleteMaster/View47DeleteAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  View47DeleteUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/View47DeleteMaster/View47DeleteUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllView47Delete(TokenKey: string, PageNumber: number, PageSize: number, orderBy: string, search: string, carriertype: string, Export: boolean): Observable<any> {
    this.setAPIUrl();
    const url = `${this.AppUrl}api/View47DeleteMaster/GetAllView47Delete`;
    const objData = {
      PageNumber,
      PageSize,
      orderBy,
      search,
      carriertype,
      export: Export
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Token: TokenKey
      })
    };

    return this._http
      .post<any>(url, objData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteView47(TokenKey: string, obligationId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/View47DeleteMaster/DeleteView47/' + obligationId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetView47DeleteById(TokenKey: string, obligationId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/View47DeleteMaster/GetView47DeleteById/' + obligationId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetView47DeletehistoryById(TokenKey: string, PageNumber: number, PageSize: number, obligationId: number, orderBy: string, FieldId: string) {
    this.setAPIUrl();
    const url = `${this.AppUrl}api/View47DeleteMaster/GetView47DeletehistoryById`;
    const objData = {
      PageNumber,
      PageSize,
      orderBy,
      obligationId,
      FieldId
    };

    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http
      .post<any>(url, objData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetView47DeleteCategory(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/View47DeleteMaster/GetView47DeleteCategory';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCarrier(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CarrierTypeObligationMaster/GetCarrier';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getCompanyIdByUserId(TokenKey: string, UserId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CarrierObligationMaster/GetCompanyIdByUserId/' + UserId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllFrontView47DeleteByUser(TokenKey: string, PageNumber: number, PageSize: number, orderBy: string, userId: number, note: string, category: string, Export: boolean) {
    this.FilterDeleteModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      orderBy,
      userId,
      note,
      category,
      export: Export
    };

    this.setAPIUrl();
    const data = 'api/View47DeleteMaster/GetAllView47DeleteActivityReport';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, this.FilterDeleteModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
